export default {
  Language: [
    {
      key: 'Fa', text: 'فارسی', value: 0, badge: 'info',
    },
    {
      key: 'En', text: 'انگلیسی', value: 1, badge: 'success',
    },
    {
      key: 'Ar', text: 'عربی', value: 2, badge: 'warning',
    },
  ],
  Status: [
    {
      key: 'Pending', text: 'در حال بررسی', value: 0, badge: 'secondary',
    },
    {
      key: 'Accepted', text: 'تایید شده', value: 1, badge: 'success',
    },
    {
      key: 'Failed', text: 'رد شده', value: 2, badge: 'warning',
    },
  ],
  IsActive: [
    {
      text: 'فعال', value: true, badge: 'success',
    },
    {
      text: 'غیرفعال', value: false, badge: 'secondary',
    },
  ],
  OpenInNewTab: [
    {
      text: 'بله', value: true, badge: 'success',
    },
    {
      text: 'خیر', value: false, badge: 'secondary',
    },
  ],
  IncludeInInvoice: [
    {
      text: 'فاکتور شود', value: true, badge: 'success',
    },
    {
      text: 'فاکتور نشود', value: false, badge: 'secondary',
    },
  ],
  PaymentType: [
    {
      text: 'نقدی', value: 0, badge: 'primary',
    },
    {
      text: 'چک', value: 1, badge: 'warning',
    },
    // {
    //   text: 'کارت - ملی', value: 2, badge: 'success',
    // },
    // {
    //   text: 'کارت - ملت', value: 3, badge: 'success',
    // },
    {
      text: 'سایر', value: 4, badge: 'success',
    },
  ],
  PettyCashType: [
    {
      text: 'هزینه', value: 0, badge: 'secondary',
    },
    {
      text: 'افزایش موجودی', value: 1, badge: 'success',
    },
  ],
  UserTransactionType: [
    {
      text: 'واریز و کسورات', value: 0, badge: 'primary',
    },
    {
      text: 'بدهی و پاداش', value: 1, badge: 'success',
    },
  ],
  AmountType: [
    {
      key: 'Percent', text: 'درصد', value: 0,
    },
    {
      key: 'Price', text: 'مبلغ', value: 1,
    },
  ],
  UserPermissionIcon: [
    { icon: 'UserIcon', color: 'secondary', key: 'User' },
    { icon: 'ApertureIcon', color: 'info', key: 'Order' },
    { icon: 'TargetIcon', color: 'success', key: 'Tour' },
    { icon: 'BookOpenIcon', color: 'primary', key: 'Blog' },
    { icon: 'BookOpenIcon', color: 'primary', key: 'Banner' },
    { icon: 'BookOpenIcon', color: 'primary', key: 'ZaerCard' },
  ],
  OrderStatus: [
    {
      value: 0, text: 'جدید', badge: 'success',
    },
    {
      value: 1, text: 'در حال پیگیری', badge: 'info',
    },
    {
      value: 2, text: 'انجام شده', badge: 'primary',
    },
    {
      value: 3, text: 'لغو شده', badge: 'warning',
    },
  ],
  ZaerCardStatus: [
    {
      value: 0, text: 'جدید', badge: 'success',
    },
    {
      value: 1, text: 'تماس گرفته شد', badge: 'info',
    },
    {
      value: 2, text: 'تأیید شده', badge: 'primary',
    },
    {
      value: 3, text: 'رد شده', badge: 'warning',
    },
  ],
  ToothNumber: [
    {
      value: 1, text: '8',
    },
    {
      value: 2, text: '7',
    },
    {
      value: 3, text: '6',
    },
    {
      value: 4, text: '5',
    },
    {
      value: 5, text: '4',
    },
    {
      value: 6, text: '3',
    },
    {
      value: 7, text: '2',
    },
    {
      value: 8, text: '1',
    },
    {
      value: 9, text: '1',
    },
    {
      value: 10, text: '2',
    },
    {
      value: 11, text: '3',
    },
    {
      value: 12, text: '4',
    },
    {
      value: 13, text: '5',
    },
    {
      value: 14, text: '6',
    },
    {
      value: 15, text: '7',
    },
    {
      value: 16, text: '8',
    },
    {
      value: 17, text: '8',
    },
    {
      value: 18, text: '7',
    },
    {
      value: 19, text: '6',
    },
    {
      value: 20, text: '5',
    },
    {
      value: 21, text: '4',
    },
    {
      value: 22, text: '3',
    },
    {
      value: 23, text: '2',
    },
    {
      value: 24, text: '1',
    },
    {
      value: 25, text: '1',
    },
    {
      value: 26, text: '2',
    },
    {
      value: 27, text: '3',
    },
    {
      value: 28, text: '4',
    },
    {
      value: 29, text: '5',
    },
    {
      value: 30, text: '6',
    },
    {
      value: 31, text: '7',
    },
    {
      value: 32, text: '8',
    },
  ],
}
